import { Api } from './axios-config';

export interface IMonthlySeries {
  year: number;
  month: number;
  value: number;
  label: string;
}

export interface IAdminDashboardView {
  totalUsers: number;
  newUsersThisMonth: number;
  totalBusinesses: number;
  activeBusinesses: number;
  newBusinessesThisMonth: number;
  appointmentsThisMonth: number;
  revenueThisMonth: number;
  usersByMonth: IMonthlySeries[];
  businessesByMonth: IMonthlySeries[];
  appointmentsByMonth: IMonthlySeries[];
  revenueByMonth: IMonthlySeries[];
}

const getDashboard = async (): Promise<IAdminDashboardView> => {
  try {
    const { data } = await Api.get<IAdminDashboardView>('/admin/dashboard');
    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

export interface IAdminBusinessView {
  id: number;
  name: string;
  address: string;
  cnpj?: string;
  ownerName?: string;
  ownerEmail?: string;
  ownerPhone?: string;
  employeeCount: number;
  appointmentsThisMonth: number;
  totalMessagesSent: number;
  isBlocked: boolean;
}

const getAllBusinesses = async (): Promise<IAdminBusinessView[]> => {
  try {
    const { data } = await Api.get<IAdminBusinessView[]>('/admin/businesses');
    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const toggleBlock = async (id: number): Promise<void> => {
  try {
    await Api.put(`/admin/businesses/${id}/block`);
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

export const adminService = {
  getDashboard,
  getAllBusinesses,
  toggleBlock,
};
